import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["submitButton", "itemizedBills", "billsPopup", "arrow", "billsContainer"]
  static values = {
    inpaintingCredit: Number // 0.5 from the model
  }

  connect() {
    // We handle only one "base_image"
    this.hasBaseImage = false

    // Hide the bills by default
    this.billsContainerTarget.classList.add("hidden")
    this.billsPopupTarget.classList.add("hidden")

    this.handleClickOutside = this.handleClickOutside.bind(this)
    document.addEventListener("click", this.handleClickOutside)

    // Check if there's already a file selected (e.g. on page load or after validation error)
    const fileInput = this.element.querySelector('input[type="file"]')
    if (fileInput && fileInput.files && fileInput.files.length > 0) {
      this.hasBaseImage = true
      this.updateDisplay()
    }
  }

  disconnect() {
    document.removeEventListener("click", this.handleClickOutside)
  }

  handleClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.billsPopupTarget.classList.add("hidden")
      this.arrowTarget.classList.remove("rotate-180")
    }
  }

  calculateCosts(event) {
    // If user selects a file => set hasBaseImage = true
    // If the file is removed => set it false
    if (event.target.files && event.target.files.length > 0) {
      this.hasBaseImage = true
    } else {
      // If the event target doesn't have files, check the actual file input
      const fileInput = this.element.querySelector('input[type="file"]')
      this.hasBaseImage = fileInput && fileInput.files && fileInput.files.length > 0
    }

    if (!this.hasBaseImage) {
      this.resetDisplay()
    } else {
      this.updateDisplay()
    }
  }

  resetDisplay() {
    const span = this.submitButtonTarget.querySelector("span:last-child")
    if (span) span.textContent = "Create Task" // fallback
    this.billsContainerTarget.classList.add("hidden")
    this.billsPopupTarget.classList.add("hidden")
    this.arrowTarget.classList.remove("rotate-180")
  }

  updateDisplay() {
    // Single image => cost = inpaintingCreditValue
    const totalCost = this.inpaintingCreditValue
    const roundedCost = Math.ceil(totalCost * 10) / 10

    // Update button text
    const span = this.submitButtonTarget.querySelector("span:last-child")
    if (span) span.textContent = `Create Task (${roundedCost} Credits)`

    // Show bills
    this.billsContainerTarget.classList.remove("hidden")
    this.itemizedBillsTarget.innerHTML = this.generateItemizedBillsHTML()
  }

  generateItemizedBillsHTML() {
    let html = `
      <div class="text-white space-y-3">
        <div class="text-lg font-medium text-gray-200 mb-3">Cost Breakdown</div>
        <div class="border border-dashed border-gray-600 rounded-lg p-4 space-y-3">
          <div class="flex justify-between items-center text-sm">
            <span>Base Image (1 × ${this.inpaintingCreditValue} credits)</span>
            <span>${this.inpaintingCreditValue} credits</span>
          </div>
        </div>
        <div class="flex justify-between items-center pt-3 text-sm font-medium">
          <span>Total:</span>
          <span class="flex items-center gap-1">
            <svg class="w-4 h-4 text-blue-400" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48
                       10 10 10 10-4.48 10-10S17.52 2
                       12 2zm0 18c-4.41 0-8-3.59-8-8s3.59
                       -8 8-8 8 3.59 8 8-3.59 8-8 8zm-1
                       -13h2v6h-2zm0 8h2v2h-2z"/>
            </svg>
            ${Math.ceil(this.inpaintingCreditValue * 10) / 10}
          </span>
        </div>
      </div>
    `
    return html
  }

  toggleBills(event) {
    event.stopPropagation()
    this.billsPopupTarget.classList.toggle("hidden")
    this.arrowTarget.classList.toggle("rotate-180")
  }
} 